var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0bqohkw5ba",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sk6fy1dobb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ga9ja5fgd",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pideia6czc",
    x1: "95.289%",
    x2: "95.289%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H19V19H0z",
    transform: "translate(-262 -20) translate(250 16) translate(12 4) translate(.5)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#0bqohkw5ba)",
    d: "M15.932 12.898l.158 1.227c0 .971-.805 1.766-1.788 1.766H9.386c-.74 0-1.341-.593-1.341-1.324 0-.732.6-1.325 1.34-1.325.584 0 1.08.369 1.265.883h3.652l.113-1.227c0-.53.222 0 .759 0 .536 0 .758-.53.758 0z",
    transform: "translate(-262 -20) translate(250 16) translate(12 4) translate(.5) translate(.792 1.583)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sk6fy1dobb)",
    d: "M16.09 8.828h-1.788V7.063c0-2.914-2.414-5.297-5.363-5.297-2.95 0-5.364 2.383-5.364 5.297v1.765H1.788V7.063C1.788 3.178 5.006 0 8.938 0c3.934 0 7.152 3.178 7.152 7.063v1.765z",
    transform: "translate(-262 -20) translate(250 16) translate(12 4) translate(.5) translate(.792 1.583)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#2ga9ja5fgd)",
    stroke: "url(#pideia6czc)",
    strokeWidth: 0.894,
    d: "M16.09 7.945h-1.788v5.297h1.788c.983 0 1.787-.794 1.787-1.765V9.71c0-.971-.804-1.766-1.787-1.766zM1.788 13.242h1.787V7.945H1.788C.804 7.945 0 8.74 0 9.711v1.766c0 .97.804 1.765 1.788 1.765z",
    transform: "translate(-262 -20) translate(250 16) translate(12 4) translate(.5) translate(.792 1.583)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcSupport);
export default __webpack_public_path__ + "static/media/icon-ic-support.8d50ce4a.svg";
export { ForwardRef as ReactComponent };